import { render, staticRenderFns } from "./AdminUserItem.vue?vue&type=template&id=1c6aaec6"
import script from "./AdminUserItem.vue?vue&type=script&lang=ts"
export * from "./AdminUserItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports